import { Component } from '@verndale/core';
import { isFocusable, keyCode } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      toggle: this.el.querySelector('.brands-drawer__toggle'),
      container: this.el.querySelector('.brands-drawer__container')
    };
  }

  addListeners() {
    this.dom.toggle.addEventListener('click', this.handleToggle.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
    document.addEventListener('focus', this.trapFocus.bind(this), true);
    this.dom.container.addEventListener(
      'keyup',
      this.handleKeyPress.bind(this)
    );
  }

  close() {
    if (this.el.classList.contains('brands-drawer--open')) {
      this.el.classList.remove('brands-drawer--open');
    }
  }

  handleToggle() {
    if (this.el.classList.contains('brands-drawer--open')) {
      this.el.classList.remove('brands-drawer--open');
      this.dom.toggle.focus();
    } else {
      this.el.classList.add('brands-drawer--open');
      setTimeout(() => {
        this.focusFirstDescendant(this.dom.container);
      }, 50);
    }
  }

  handleKeyPress(e) {
    const key = e.which || e.keyCode;

    if (key === keyCode.ESC) {
      e.stopPropagation();
      this.el.classList.remove('brands-drawer--open');
      this.ignoreUtilFocusChanges = true;
      this.dom.toggle.focus();
    }
  }

  handleClickOutside(e) {
    if (this.el !== e.target && !this.el.contains(e.target)) {
      this.el.classList.remove('brands-drawer--open');
    }
  }

  trapFocus(e) {
    if (this.ignoreUtilFocusChanges) {
      return;
    }

    if (this.dom.container.contains(e.target)) {
      this.lastFocus = e.target;
    } else {
      this.focusFirstDescendant(this.dom.container);
      if (this.lastFocus === document.activeElement) {
        this.focusLastDescendant(this.dom.container);
      }
      this.lastFocus = document.activeElement;
    }
  }

  focusFirstDescendant(element) {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  focusLastDescendant(element) {
    for (let i = element.childNodes.length - 1; i >= 0; i--) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  attemptFocus(element) {
    if (!isFocusable(element)) {
      return false;
    }

    this.ignoreUtilFocusChanges = true;

    try {
      element.focus();
    } catch (e) {
      console.log('Element can not be focused');
    }

    this.ignoreUtilFocusChanges = false;

    return document.activeElement === element;
  }
}

export default Module;
